import { createSlice } from "@reduxjs/toolkit";

export const TERMINAL_TRAINING_STATES = ["succeeded", "failed"];

const NO_TRAIN_POST = { out: 0, run: null, liveModelId: null };

// Training per feature, kept outside the Model tab: switching tabs unmounts it
// while a POST is out or its run is followed, and the next instance must know.
const trainPostsSlice = createSlice({
  name: "trainPosts",
  initialState: {},
  reducers: {
    trainPostSent: (state, action) => {
      const featureId = action.payload;
      const post = state[featureId] || { ...NO_TRAIN_POST };
      post.out += 1;
      state[featureId] = post;
    },
    // `jobId` is the 202's training_job_id: the run this POST started. A
    // rejected POST, or a 202 without it, leaves the recorded run as it was.
    trainPostSettled: (state, action) => {
      const { featureId, jobId } = action.payload;
      const post = state[featureId];
      if (post == null) return;
      post.out -= 1;
      if (jobId != null) post.run = { jobId, state: null, timedOut: false };
    },
    // The run's state as the model GET last showed it; `null` until then. A
    // finished run stays finished.
    ownRunSeen: (state, action) => {
      const { featureId, jobId, state: runState } = action.payload;
      const run = state[featureId]?.run;
      if (run?.jobId !== jobId) return;
      if (TERMINAL_TRAINING_STATES.includes(run.state)) return;
      run.state = runState;
    },
    ownRunTimedOut: (state, action) => {
      const { featureId, jobId } = action.payload;
      const run = state[featureId]?.run;
      if (run?.jobId === jobId) run.timedOut = true;
    },
    // The active model the Model tab last saw, for Prognozė to check its
    // predictions against.
    modelWentLive: (state, action) => {
      const { featureId, modelId } = action.payload;
      const post = state[featureId] || { ...NO_TRAIN_POST };
      post.liveModelId = modelId;
      state[featureId] = post;
    },
  },
});

export const {
  trainPostSent,
  trainPostSettled,
  ownRunSeen,
  ownRunTimedOut,
  modelWentLive,
} = trainPostsSlice.actions;

export default trainPostsSlice.reducer;

export const selectTrainPost = (state, featureId) =>
  state.trainPosts[featureId] ?? NO_TRAIN_POST;

// The tab follows the run it started until the model GET shows that run
// finished, or the 20-minute backstop fires.
export const isOwnRunFollowed = (run) =>
  run != null && !run.timedOut && !TERMINAL_TRAINING_STATES.includes(run.state);
